module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_net_pots2.458b7760.webp";